<vis-toast></vis-toast>
@if (maintenanceMode) {
	<vis-maintenance></vis-maintenance>
} @else if (auth.authenticationComplete() && (!auth.authenticated() || auth.accountInfoReady())) {
	<router-outlet></router-outlet>
} @else {
	<vis-splash></vis-splash>
}
